import { Grid } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import Config from "../../config";
import { useLocation, useNavigate } from "react-router-dom";
import { GoToPlansPrimaryIcon, GoToPlansSecondaryIcon, PaymentAwaitedIcon, PaymentFailedIcon, PaymentSuccessIcon, PrintIcon } from "../../icon";
import { IInvoiceModel, mapChargebeeInvoice, PaymentStatus } from "../../models/payment.model";
import { UserService } from "../../services/UserService";
import { UtilityService } from "../../services/UtilityService";
import { AppRoutes } from "../routes/route.path";
import ButtonComponent from "../shared/button/button.component";
import { appNote, buttonLabels, ViewTextLabels } from "../shared/constants";
import { useSelector } from "react-redux";
import * as selector from "../../selectors/selectors";
import { setHeaderTitle } from "../../helpers/header.helper";

interface IProps {
    IsTeamsApp: boolean;
    Stepdata: any
}

const NewPaymentStatus = (props: IProps) => {
    const location = useLocation();
    const navigate = useNavigate();
    let StatusInterval: NodeJS.Timeout;

    const [invoice, setInvoice] = useState<IInvoiceModel>()
    const [paymentStatus, setPaymentStatus] = useState(PaymentStatus.AWAITING)

    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)


    useEffect(() => {
        let { status } = getData();

        setPaymentStatus(status || PaymentStatus.AWAITING);

        if (!StatusInterval && (status === PaymentStatus.AWAITING || !status)) {
            StatusInterval = setInterval(getPaymentStatus, 2000)
        }
        setHeaderTitle("Payment Status")
        return () => { clearStatusInterval() };
    }, [])

    const clearStatusInterval = () => {
        if (StatusInterval) {
            clearInterval(StatusInterval)
        }
    }

    const getPaymentStatus = () => {
        let { paymentID } = getData();
        if (paymentID) {
            axios.get(`${Config.CHARGEBEE_INTEGRATION_API_URL}/get-host-page?id=${paymentID}`,).then((response) => {
                let paymentStatus = (!!response.data.hosted_page?.content?.invoice?.linked_payments?.every(x => x.txn_status === "success") || response.data.hosted_page?.state === "succeeded") ? PaymentStatus.SUCCESS : PaymentStatus.FAILED;
                setPaymentStatus(paymentStatus)
                setInvoice(paymentStatus === PaymentStatus.SUCCESS ? mapChargebeeInvoice(response.data.hosted_page.content.invoice) : undefined)
                clearStatusInterval();
            }).catch(error => { });
        }
        else {
            setPaymentStatus(PaymentStatus.FAILED)
        }
    }

    const getData = () => {
        if (props.Stepdata) {
            return { paymentID: props.Stepdata?.paymentID, status: props.Stepdata?.state, OrganizationID: props.Stepdata?.OrganizationID };
        }
        else {
            let urlParams = new URLSearchParams(location.search);
            let OrganizationID = urlParams.get("OrganizationID") || "";
            let paymentID = urlParams.get("id") || "";
            let status = parseInt(urlParams.get("state") || "") as PaymentStatus;
            return { paymentID, status, OrganizationID };
        }
    }

    const handlePrint = () => {
        window.print();
    }

    const goToHome = (e: any) => {
        e.preventDefault()
        let { OrganizationID } = getData();
        UserService.hasSysAdminRole() ? (
            navigate(AppRoutes.NEW_ORGANIZATION, { state: { OrganizationID } })
        ) : (
            navigate(AppRoutes.PLANS)
        );

    }

    const formatNumber = number => {
        const [integerPart, decimalPart] = String(number).split('.');
        const paddedDecimalPart = decimalPart ? decimalPart.padEnd(2, '0') : '00';
        return `${integerPart || '0'}.${paddedDecimalPart}`;
    };


    return (
        paymentStatus === PaymentStatus.SUCCESS ?
            <div className={`d-flex h-p-100 w-fill  px-2 b-none ${(location.state as any)?.IsSignUp || ((location.state as any)?.IsRecharge && IsMobileDevice) ? '' : ''}  `}>

                <div className={` ${IsMobileDevice ? 'w-p-100' : 'w-p-90 settings-paper-border px-8  br-3  max-h-fill '} t-align-center printme`}>
                    <div id="print">
                        <div className={`pt-2`}> <PaymentSuccessIcon /> </div>
                        <div className={`h1-semibold color-primary-success pb-1 pt-1`} >{appNote.PAYMENT_SUCCESSFUL} </div>

                        <div className="h4-regular color-secondary-accent pb-4">{appNote.THANK_YOU_FOR_PAYMENT}<br /> {appNote.PROCESSED_SUCCESSFULLY}</div>
                        <div className="bb-primary-background-pink-4"></div>

                        <Grid container className={"mt-3"} direction="row" spacing={3} >
                            <Grid item xs={IsMobileDevice ? 12 : 6} md={6}>
                                <Grid container >
                                    <Grid item xs={6} className={`h5-semibold my-1 color-primary-accent w-space t-align-left `}>
                                        {ViewTextLabels.TRANSACTION_ID}
                                    </Grid>
                                    <Grid item xs={6} className={`h6-regular my-1 my-auto t-align-left payment-status-word `} id="print-font" >
                                        {invoice?.SubscirptionID || getData().paymentID}
                                    </Grid>
                                    <Grid item xs={6} className={`h5-semibold my-1 color-primary-accent t-align-left pb-1`} >
                                        {ViewTextLabels.PLANS}
                                    </Grid>
                                    <Grid item xs={6} className={`h6-regular my-1 t-align-left`} id="print-font">
                                        {invoice?.PlanItemName.substring(invoice?.PlanItemName.indexOf(' ') + 1) || "--"}
                                    </Grid>
                                    <Grid item xs={6} className={`h5-semibold my-1 color-primary-accent t-align-left pb-1`}>
                                        {ViewTextLabels.DATE}
                                    </Grid>
                                    <Grid item xs={6} className={` h6-regular my-1 t-align-left`} id="print-font">
                                        {invoice?.PaidDateTime ? UtilityService.convertDateToDay(invoice?.PaidDateTime) : "--"}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={IsMobileDevice ? 12 : 6} md={6}>
                                <Grid container>
                                    <Grid item xs={6} className={`h5-semibold my-1 color-primary-accent t-align-left  `}>
                                        {ViewTextLabels.PRICE}
                                    </Grid>
                                    <Grid item xs={6} className={`h6-regular my-1 t-align-left `} id="print-font">
                                        {invoice?.PaidAmount > 0 && '$'}{invoice?.PaidAmount > 0 ? formatNumber(invoice?.PaidAmount / 100) : "--"}
                                    </Grid>
                                    <Grid item xs={6} className={`h5-semibold my-1 color-primary-accent t-align-left `}>
                                        {ViewTextLabels.INVOICE_ID}
                                    </Grid>
                                    <Grid item xs={6} className={`h6-regular my-1 w-space t-align-left `} id="print-font">
                                        {invoice?.ID}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>

                    <div className={`${IsMobileDevice ? 'mx-auto' : 'd-flex t-align-center justify-center'} my-3 no-printme`}>
                        <ButtonComponent OnClick={handlePrint}
                            ButtonLabel={buttonLabels.PRINT.toLocaleUpperCase()}
                            ClassName={`c-pointer  ${IsMobileDevice ? 'w-p-100 justify-center mb-2' : 'mr-2'} `}
                            Variant={"secondary-btn-small"}
                            Icon={PrintIcon}
                        />
                        <ButtonComponent OnClick={goToHome}
                            ButtonLabel={UserService.hasSysAdminRole() ? buttonLabels.GO_TO_ORGANIZATIONS : buttonLabels.GO_TO_PHONE_NUMBERS}
                            ClassName={`c-pointer  ${IsMobileDevice ? 'w-p-100 justify-center mb-2' : 'mr-2'}`}
                            Variant={"primary-btn-small"}
                            Icon={(location.state as any)?.IsSignUp ? undefined : GoToPlansPrimaryIcon}
                        />
                    </div >
                </div>
            </div >

            : paymentStatus === PaymentStatus.FAILED ?
                <div className={`d-flex px-auto w-fill px-2 h-p-100 ${(location.state as any)?.IsSignUp ? '' : 'paper-background'} mx-auto `}>
                    <div className=" py-8 px-4 w-p-100 t-align-center printme b-around-text-field-border-4 br-3">
                        <div >
                            <div className={`pt-4`}>
                                <PaymentFailedIcon />
                            </div>
                            <div className={`h1-semibold pb-1 pt-1 color-primary-danger`}>
                                {appNote.PAYMENT_FAILED}
                            </div>

                            <div className="h4-regular color-secondary-accent pb-4">{appNote.SOMETHING_WENT_WRONG}<br /> {appNote.TRY_AGAIN}</div>
                        </div>

                        <div className="d-flex t-align-center justify-center mt-5 mb-2 no-printme">
                            <ButtonComponent OnClick={goToHome}
                                ButtonLabel={UserService.hasSysAdminRole() ? buttonLabels.GO_TO_ORGANIZATIONS : buttonLabels.GO_TO_PHONE_NUMBERS}
                                ClassName={"c-pointer mr-2"}
                                Variant={"secondary-btn-small"}
                                Icon={GoToPlansSecondaryIcon}
                            />
                        </div >
                    </div>
                </div >
                : <div className={`d-flex px-auto w-fill px-2 h-p-100 ${(location.state as any)?.IsSignUp ? '' : 'paper-background'} mx-auto `}>
                    <div className="px-4 w-p-100 t-align-center printme b-around-text-field-border-4 br-3">
                        <div id="print">
                            <div className={`pt-4`}>
                                <PaymentAwaitedIcon />
                            </div>
                            <div className={`h1-semibold pb-1 pt-1 color-primary-warning`}>
                                {appNote.PAYMENT_AWAITED}
                            </div>

                            <div className="h4-regular t-align-center color-secondary-accent pb-4">{appNote.PAYMENT_AWAITED_NOTE}</div>
                        </div>

                        <div className="d-flex t-align-center justify-center mt-5 no-printme">
                            <ButtonComponent OnClick={goToHome}
                                ButtonLabel={UserService.hasSysAdminRole() ? buttonLabels.GO_TO_ORGANIZATIONS : buttonLabels.GO_TO_PHONE_NUMBERS}
                                ClassName={"c-pointer mr-2"}
                                Variant={"primary-btn-small"}
                                Icon={GoToPlansPrimaryIcon}
                            />
                        </div >
                        <div className="footnote t-align-center color-secondary-accent pt-2">{appNote.PAYMENT_AWAITED_FOOT_NOTE}</div>
                    </div>
                </div >
    )
}

export default NewPaymentStatus;